module.exports = __webpack_public_path__ + "static/media/208shi.7cfae015.jpg";